import { render, staticRenderFns } from "./uiobs3Mensajes.vue?vue&type=template&id=54c06a36&scoped=true"
import script from "./uiobs3Mensajes.vue?vue&type=script&lang=js"
export * from "./uiobs3Mensajes.vue?vue&type=script&lang=js"
import style0 from "./uiobs3Mensajes.vue?vue&type=style&index=0&id=54c06a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c06a36",
  null
  
)

export default component.exports